import React from 'react';

import calendarUtils from '../../utils/calendar';

import './styles.scss';

const PanelControl = ({
  startTime,
  endTime,
  startDate,
  endDate,
  weekDays,
  isWeekDaysEnabled,
  isTimeEnabled,
  setCalendarOpen,
  applyChanges
}) => {
  const shouldDisableApplyButton = () => {
    const start = startTime || calendarUtils.placeholders.startTime;
    const end = endTime || calendarUtils.placeholders.endTime;

    const areDatesInvalid = !startDate;
    const areTimesInvalid = calendarUtils.isInvalidTime(start) || calendarUtils.isInvalidTime(end) || start > end;
    const areDaysInvalid = weekDays.length === 0;

    return areDatesInvalid || (isTimeEnabled && areTimesInvalid) || (isWeekDaysEnabled && areDaysInvalid);
  };

  // Disable Apply button if date range is greater than 6 months (approx. 185 days)
  const difference = calendarUtils.getMonthsDifference(startDate, endDate);
  const isRangeTooLarge = difference > 6;

  return (
    <div className="panel-controls">
      <button type="button" className="btn btn-block btn-link" onClick={() => setCalendarOpen(false)}>
        Close
      </button>
      <button
        type="button"
        className="btn btn-block btn-primary apply-btn"
        disabled={shouldDisableApplyButton() || isRangeTooLarge}
        onClick={applyChanges}
      >
        Apply
      </button>
    </div>
  );
};

export default PanelControl;
